import React from "react";
import BannerListPresenter from "./BannerList.presenter";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./BannerList.type";
import {
  BannerOutputModel,
  RootState,
  TCb,
  LanguageOutputModel,
  AppNotifications
} from "../../../../../models";
import { NotificationActions, AllLanguageListActions } from "../../../../../store/actions";
import _ from "lodash";

import { APP_ROUTES, INITIAL_FETCHING_PAGINATION_DATA } from "../../../../../constants";

import { BannerService } from "../../../../../services";
import { BannerUtil, loadCallback } from "../../../../../utils";
import { withRouter } from "react-router-dom";

const EMPTY_FILTER: C_States["filter"] = {
  searchValue: "",
};

class BannerListContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    const bannerCode = this.props.match.params.bannerCode;

    this.state = {
      filter: EMPTY_FILTER,
      fetchedBanner: INITIAL_FETCHING_PAGINATION_DATA,
      visibleBannerCode: bannerCode,
      visibleBannerForm: Boolean(bannerCode),

      activeLanguageId: "",
      languageData: [],
      amountPost: 0
    };
  }

  openBannerFormModal = (bannerCode?: string) => {
    this.setState({ visibleBannerCode: bannerCode, visibleBannerForm: true }, () => {
      if (bannerCode) {
        this.props.history.push(BannerUtil.buildBannerDetailPath(bannerCode));
      }
    });
  };

  closeBannerFormModal = (cb?: TCb) => {
    this.props.history.push(APP_ROUTES.PAGEMANAGEMENT.BANNER.BASE);
    this.setState({ visibleBannerCode: undefined, visibleBannerForm: false }, () => {
      loadCallback(cb?.success);
    });
  };

  onDeleteBanner = (bannerCode) => {
    BannerService.deleteBanner(bannerCode)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.onApplyFilter(false);
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete banner success",
          });
          loadCallback(this.props.onComplete_Delete);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete banner failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete banner failed" });
      });
  };

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  }, 300);

  onApplyFilter = (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedBanner.loading && loadMore) return;
    this.props.all_language_list.data.forEach((e: LanguageOutputModel) => {
      if (e.isPrimary) {
        this.setState({
          activeLanguageId: e.id,
        })
      }
    })

    this.setState(
      (prevState) => {
        return {
          fetchedBanner: {
            ...prevState.fetchedBanner,
            data: loadMore ? prevState.fetchedBanner.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof BannerService.getAllBannerByLanguage>[0] = {
          page: loadMore ? this.state.fetchedBanner.page + 1 : 1,
          limit: this.state.fetchedBanner.limit,
          languageId: this.state.activeLanguageId,
          searchValue: this.state.filter.searchValue || undefined
        };

        BannerService.getAllBannerByLanguage(query)
          .then((res) => {
            if (res && res.data?.data) {
              this.setState(
                (prevState) => {
                  let banners: BannerOutputModel[] = [...res.data.data];

                  if (loadMore) {
                    banners.unshift(...prevState.fetchedBanner.data);
                  }

                  return {
                    fetchedBanner: {
                      ...res.data,
                      data: banners,
                      loading: false,
                    },
                  };
                },
                () => {
                  loadCallback(cb?.success);
                }
              );
            } else {
              this.setState({
                fetchedBanner: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.setState({
              fetchedBanner: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      }
    );
  };

  onLoadMore = () => {
    this.onApplyFilter(true);
  };

  componentDidMount() {
    if (!this.props.all_language_list.data.length) {
      this.props.actions.getAllLanguages({
        success: () => {
          this.onApplyFilter(false);
        }
      })
    }
    else {
      this.onApplyFilter(false);
    }
  }

  render() {
    return (
      <BannerListPresenter
        {...this.props}
        {...this.state}
        onLoadMore={this.onLoadMore}
        onSearch={this.onSearch}
        openBannerFormModal={this.openBannerFormModal}
        closeBannerFormModal={this.closeBannerFormModal}
        reloadListingPage={() => {
          this.onApplyFilter(false);
        }}
        onDeleteBanner={this.onDeleteBanner}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    })
  )(BannerListContainer)
);
